//Polygon types
export const POLYGON_TYPE_COMMUNITY = 'Community';
export const POLYGON_TYPE_LOT = 'Lot';
export const POLYGON_TYPE_POI = 'PlaceOfInterest';
export const POLYGON_TYPE_NEW = 'New';
//Lot Map statuses
export const POLYGON_LOT_MAP_STATUS_SOLD = 'Sold';
export const POLYGON_LOT_MAP_STATUS_UNAVAILABLE = 'Unavailable';
export const POLYGON_LOT_MAP_STATUS_UNDER_CONSTRUCTION = 'Under Construction';
export const POLYGON_LOT_MAP_STATUS_MOVE_IN_READY = 'Move-In Ready';
export const POLYGON_LOT_MAP_STATUS_AVAILABLE_HOME_SITE = 'Available HomeSite';
export const POLYGON_LOT_MAP_STATUS_MODEL = 'Model';
// Lot status
export const POLYGON_LOT_STATUS_SPEC_MODEL = 'SpecModel';
export const POLYGON_LOT_STATUS_PENDING = 'Pending';
export const POLYGON_LOT_STATUS_AVAILABLE = 'Available';
export const POLYGON_LOT_STATUS_UNRELEASED = 'Unreleased';
export const POLYGON_LOT_STATUS_CLOSED = 'Closed';
export const POLYGON_DEFAULT_FILL = '#c7291e';
export const POLYGON_CMP_FILL = '#007cad';
export const POLYGON_CCS_FILL = '#4a104a';
export const POLYGON_LOT_FILL = '#f7f7f7';
export const POLYGON_SELECTED_FILL = '#fff';
export const POLYGON_POI_FILL = '#51771c';
export const POLYGON_COMMUNITY_FILL = '#FFF';
export const POLYGON_DISABLED_FILL = '#b1b1b1';
export const POLYGON_LOT_SOLD_COLOR = '#5a5a5a';
export const POLYGON_LOT_MODEL_COLOR = '#4a104a';
export const POLYGON_LOT_UNAVAILABLE_COLOR = '#d4d4d4';
export const POLYGON_LOT_FUTURE_UNDER_CONSTRUCTION_COLOR = '#8a608e';
export const POLYGON_LOT_MOVE_IN_READY_COLOR = '#007cad';
export const POLYGON_LOT_AVAILABLE_COLOR = '#007cad';
export const CHECKBOX_CHECKMARK_COLOR_LIGHT = '#fff';
export const CHECKBOX_CHECKMARK_COLOR_DARK = '#222';
export const POLYGON_DEFAULT_STROKE = '#c7291e';
export const POLYGON_CMP_STROKE = '#007cad';
export const POLYGON_CCS_STROKE = '#4a104a';
export const POLYGON_LOT_STROKE = '#b1b1b1';
export const POLYGON_SELECTED_STROKE = '#fff';
export const POLYGON_POI_STROKE = '#51771c';
export const POLYGON_COMMUNITY_STROKE = '#4a104a';
export const POLYGON_DISABLED_STROKE = '#b1b1b1';
export var EDIT_TYPES;
(function (EDIT_TYPES) {
    EDIT_TYPES["EDIT_POLYGON"] = "edit-polygon";
    EDIT_TYPES["SAVE_ONLY"] = "save-only";
})(EDIT_TYPES || (EDIT_TYPES = {}));
export var DRAW_MODE;
(function (DRAW_MODE) {
    DRAW_MODE["POLYGON"] = "polygon";
    DRAW_MODE["MARKER"] = "marker";
})(DRAW_MODE || (DRAW_MODE = {}));
export const SHAPE_TYPE_POLYGON = 'Polygon';
export const SHAPE_TYPE_PIN = 'Point';
export const MIN_VIEWPORT_WIDTH_ALLOWED = 1200;
export const MIN_DESKTOP_BREAKPOINT = 992;
export const EDIT_MODE_NORMAL = 'edit';
export const EDIT_MODE_ADD = 'add';
export const EDIT_MODE_SAVE_ONLY = 'saveonly';
// centers the US in frame
export const MAP_DEFAULT_ZOOM = 17;
export const MAP_DEFAULT_LAT = 38.539628;
export const MAP_DEFAULT_LONG = -95.721334;
export const POLYGON_VISIBLE_ZOOM_BREAKPOINT = 15;
export const POLYGON_DEFAULT_ZOOM = 17;
export const GOOGLE_MAP_LIBRARIES = ['drawing'];
export const CLOSE_DROPDOWN_EVENT_NAME = 'viewportCloseDropdown';
